import { render, staticRenderFns } from "./SidebarUserSection.vue?vue&type=template&id=37f121fa&scoped=true"
import script from "./SidebarUserSection.vue?vue&type=script&lang=js"
export * from "./SidebarUserSection.vue?vue&type=script&lang=js"
import style0 from "./SidebarUserSection.vue?vue&type=style&index=0&id=37f121fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f121fa",
  null
  
)

export default component.exports